import React from "react";
import {Box, Grid, Link, Paper, Typography} from "@mui/material";
import PropTypes from "prop-types";
import Analytics from "../../libs/analytics";
import SimpleBar from "simplebar-react";
import 'simplebar-react/dist/simplebar.min.css';
import Dotdotdot from "react-dotdotdot";
import common from "../../utils/common";

const isString = value => typeof value === "string";
const formatPrice = (price) => {
    if (price && isString(price)) {
        if (price.indexOf("$") >= 0) {
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toFixed(2);
            return price.replace(onlyPrice, formattedPrice);
        } else {
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toFixed(2);
            return "$" + price.replace(onlyPrice, formattedPrice);
        }
    } else if (typeof price === "number") {
        return "$" + Number(price).toFixed(2);
    } else {
        return price
    }
}
const clearPrice = value => isString(value) ? value.replace(/[^\d.]/g, '') : value;
const RenderPrice = (entity) => {
    const product = entity.data && typeof entity.data === 'object' ? {...entity, ...entity.data} : entity;
    if (product.price && product.price_sale) {
        const onlyPrice = Number(clearPrice(product.price));
        const onlyPriceSale = Number(clearPrice(product.price_sale));
        if (onlyPriceSale < onlyPrice) {
            return <span>
                    <span style={{color: "#d00000"}}>{formatPrice(product.price_sale)}</span> <strike
                style={{color: "#2b2b2b"}}
                className={"old-price"}>{formatPrice(product.price)}</strike></span>;
        }
    }
    return formatPrice(product.price)
}

const ProductsVertical = ({ambassador, products, height}) => {

    const sendPKEvent = (e, product) => {
        const {asset} = window.TVSite.channelVideosData;
        Analytics.productClick(product, asset.id);
        return e;
    }

    return <Box px={2}>
        <SimpleBar style={{overflowX: "hidden", height: height || '100%'}}>
            <Box display="flex" width={"100%"}>
                <Grid container spacing={2}>
                    {
                        products.map((item, index) => {
                            const {title, data:{imageUrl, linkUrl}} = item;
                            return <Grid item xs={12} key={item.id} sx={{minWidth: '100%'}}>
                                <Link color="inherit" href={common.addSharedIdToUrl(linkUrl, ambassador?.user_id, item.id || item.product_id)} onClick={(e) => sendPKEvent(e, item)}
                                      target={"_blank"}
                                      sx={{
                                          textDecoration: "none !important",
                                          "&:hover, &:focus": {
                                              textDecoration: "none !important"
                                          }
                                      }}
                                >
                                    <Paper elevation={0} square>
                                        <Box p={2}>
                                            <Box paddingTop={'133.8%'} width={'100%'} position={'relative'}
                                                 display={'flex'} justifyContent={'center'}>
                                                <img src={imageUrl} alt={title} height={'100%'}
                                                     style={{position: 'absolute', top: 0}}/>
                                            </Box>
                                            <Box>
                                                <Typography fontSize={"14px"}>
                                                    <Dotdotdot clamp={2}>
                                                        {title}
                                                    </Dotdotdot>
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography fontSize={"14px"}>
                                                {RenderPrice(item)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Link>
                            </Grid>
                        })
                    }
                </Grid>
            </Box>
        </SimpleBar>
    </Box>
}

ProductsVertical.propTypes = {
    ambassador: PropTypes.object,
    products: PropTypes.array.isRequired
}
ProductsVertical.defaultProps = {
    products: []
};

export default ProductsVertical;
